import type { BaseHttpRequest } from '@/api/generated-client/core/BaseHttpRequest';
import { ListGameCommentsParameters } from '@/api/parameters';
import {
  GameCommentDto,
  PaginatedGameCommentsResponseDto, UpdateGameCommentRequestDto
} from '@/api/models';
import { UserProfile } from '@/api/models/user-profile.dto';
import { BaseApi } from '@/api/base-api';

export class CommentsApi extends BaseApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {
    super();
  }

  private controller = '/catalog/comments';

  public async listGameComments(query: ListGameCommentsParameters): Promise<PaginatedGameCommentsResponseDto> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/game-comments?${this.queryToQueryString(query)}`,
      {}
    );
  }

  public async getGameComment(id: number): Promise<GameCommentDto & UserProfile> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/game-comments/${id}`,
      {}
    );
  }

  public async updateGameComment(
    id: number,
    data: UpdateGameCommentRequestDto
  ): Promise<GameCommentDto & UserProfile> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[PATCH] /api/v1/game-comments/${id}`,
      data,
    );
  }
}
